import React, {useEffect} from "react";

const Footer = () => {
    return (
      <section>
        {/* <p>Footer</p> */}
      </section>
    );
}

export default Footer